// The Nexus Dijital wordmark. First letter of each word is red per brand
// kit: "N" of NEXUS and "D" of DİJİTAL. Turkish dotted İ matters.
//
// Color: we explicitly set `text-primary` so the wordmark renders
// correctly inside containers that don't propagate the default body
// color. Without this, the logo would render as the browser's default
// (near-black) inside the app-shell header — invisible on the dark
// `bg-shell` surface. The `logo-accent` class on N + D paints those
// two letters red regardless of the surrounding color.
export function Logo({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  const cls = {
    sm: "text-base",
    md: "text-lg",
    lg: "text-2xl",
  }[size];
  return (
    <span className={`font-display font-bold tracking-tight text-primary ${cls}`}>
      <span className="logo-accent">N</span>EXUS <span className="logo-accent">D</span>İJİTAL
    </span>
  );
}
